"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ControlMessage_1 = __importDefault(require("../ControlMessage"));
const StreamMessage_1 = __importDefault(require("../../message_layer/StreamMessage"));
const BroadcastMessage_1 = __importDefault(require("./BroadcastMessage"));
const Serializer_1 = require("../../../Serializer");
const VERSION = 2;
/* eslint-disable class-methods-use-this */
class BroadcastMessageSerializerV2 extends Serializer_1.Serializer {
    toArray(broadcastMessage, streamMessageVersion = StreamMessage_1.default.LATEST_VERSION) {
        return [
            VERSION,
            ControlMessage_1.default.TYPES.BroadcastMessage,
            broadcastMessage.requestId,
            StreamMessage_1.default.getSerializer(streamMessageVersion).toArray(broadcastMessage.streamMessage),
        ];
    }
    fromArray(arr) {
        const [version, _type, requestId, serializedStreamMsg,] = arr;
        return new BroadcastMessage_1.default({
            version,
            requestId,
            streamMessage: StreamMessage_1.default.deserialize(serializedStreamMsg),
        });
    }
}
exports.default = BroadcastMessageSerializerV2;
ControlMessage_1.default.registerSerializer(VERSION, ControlMessage_1.default.TYPES.BroadcastMessage, new BroadcastMessageSerializerV2());
//# sourceMappingURL=BroadcastMessageSerializerV2.js.map